import { UserRoleType } from "@/constants/auth";
import type { CurrentUser } from "@/types/general";

const EDUCATION_OFFICER_ROLE_SLUGS = new Set([
  "education-officer",
  "education-supervisor",
  "egitim-sorumlusu",
]);

function normalizeRoleSlug(raw: string): string {
  return raw.trim().toLowerCase().replace(/_/g, "-");
}

function roleMatchesEducationOfficer(slug: string | undefined): boolean {
  if (!slug?.trim()) return false;
  return EDUCATION_OFFICER_ROLE_SLUGS.has(normalizeRoleSlug(slug));
}

/** Oturum eğitim sorumlusu mu (JWT userType veya rol adı / roles[]) */
export function isEducationOfficerSession(
  userType: number | null,
  user: CurrentUser | null,
): boolean {
  if (userType === UserRoleType.EDUCATION_SUPERVISOR) return true;
  if (roleMatchesEducationOfficer(user?.role)) return true;
  const roles = user?.roles;
  if (Array.isArray(roles)) {
    return roles.some((r) => roleMatchesEducationOfficer(r?.name));
  }
  return false;
}
